import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { PDFViewer } from '@react-pdf/renderer';
import ReactPDF from '@react-pdf/renderer';
import { styled } from '@mui/material/styles';
import axios from "axios";
import "./styles.css";

import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Switch,
  FormControlLabel,
  FormGroup,
  Popover,
  Checkbox,
  TableHead,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';

import WorkerCreate from '../pages/WorkerCRUDPages/create';

export default function EmployeesListForCompany({ companyId }) {
  const [employees, setEmployees] = useState([]);
  const [showbuildingcreate, setShowBuildingCreate] = useState('');
  const [loading, setLoading] = useState(false);
  const [zones, setZones] = useState([]);
  const [dataloaded, setDataLoaded] = useState(false);
  const navigate = useNavigate();
  const [deleteWorker, setDeleteWorker] = useState(null);

  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  useEffect(() => {
    if (companyId) {
      axios
        .get(`${SERVER_URL}/api/workers/by-company/${companyId}`)
        .then((res) => setEmployees(res.data))
        .catch(() => console.log("Greška pri učitavanju zaposlenika"));
    }
  }, [companyId, dataloaded]);

  const handleDeleteWorker = async () => {
    try {
      await axios.delete(`${SERVER_URL}/api/workers/${deleteWorker.id}`);
      setDeleteWorker(null);
      setDataLoaded(prev => !prev);
    } catch (err) {
      console.error("Greška pri brisanju radnika", err);
    }
  };

  return (
    <>
      <Helmet>
        <title>Pametna rasvjeta</title>
      </Helmet>

      <Container
        maxWidth={false}
        sx={{
          backgroundColor: '#00122E',
          minHeight: '70vh',
          padding: '20px',
          borderRadius: '8px',
        }}
      >
        <div>
          <Button
            sx={{
              minWidth: 100,
              backgroundColor: '#001B44',
              color: '#ff9800',                // 🔥 tekst orange
              border: '1px solid #ff9800',     // 🔥 border orange
              '&:hover': {
                backgroundColor: '#001B44',
                border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                color: '#ffa726'
              }
            }}
            onClick={() => setShowBuildingCreate(!showbuildingcreate)}
          >
            Dodaj novog radnika
          </Button>

          {showbuildingcreate &&
            <WorkerCreate
              companyid={companyId}
              onSuccess={() => {
                setShowBuildingCreate(false);
                setDataLoaded(!dataloaded);
              }}
              onCancel={() => {
                setShowBuildingCreate(false);
              }}

              className="child"
            />
          }
        </div>

        <TableContainer
          component={Paper}
          sx={{
            mt: 3,
            backgroundColor: '#00122E',
            borderRadius: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              p: 2,
              pl: 3,
              color: '#ff9800',
              fontWeight: 600,
              textAlign: "left"
            }}
          >
            Zaposlenici kompanije
          </Typography>

          <Table
            sx={{
              width: '100%',
              tableLayout: 'fixed',

              '& .MuiTableCell-root': {
                borderBottom: '1px solid #374151',
                textAlign: 'center',   // ✅ FIX
              },

              '& .MuiTableCell-head': {
                color: '#ff9800 !important',
                borderBottom: '2px solid #374151',
              }
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: '#001B44',
                  '& .MuiTableCell-root': {
                    backgroundColor: '#001B44',
                    color: '#ff9800',
                    fontWeight: 700,
                    fontSize: '13px',
                    letterSpacing: '0.5px',
                    //borderBottom: '2px solid #3949ab',
                    padding: '10px',
                    textAlign: 'center'   // 👈 KLJUČNO
                  }
                }}
              >
                {[
                  'Ime',
                  'Prezime',
                  'Pozicija',
                  'Email',
                  'Telefon',
                  'Aktivan',
                  'Odjel',
                  'Napomene',
                  'Uredi',
                  'Obriši'
                ].map((h) => (
                  <TableCell
                    key={h}
                    sx={{
                      color: '#ff9800',   // 🔥 OVO JE KLJUČ
                      fontWeight: 700,
                      fontSize: '13px',
                      textAlign: 'center',
                      borderBottom: '2px solid #374151',
                      backgroundColor: '#001B44'
                    }}
                  >
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {employees.map((e) => (
                <TableRow
                  hover
                  key={e.id}
                  tabIndex={-1}
                  sx={{
                    '&:hover': {
                      backgroundColor: '#001B44', // nova boja na hover
                    },
                  }}
                >
                  <TableCell sx={{ color: '#ff9800' }}>{e.firstName}</TableCell>
                  <TableCell sx={{ color: '#ff9800' }}>{e.lastName}</TableCell>
                  <TableCell sx={{ color: '#ff9800' }}>{e.position}</TableCell>
                  <TableCell sx={{ color: '#ff9800' }}>{e.email}</TableCell>
                  <TableCell sx={{ color: '#ff9800' }}>{e.phoneNumber}</TableCell>
                  <TableCell sx={{ color: '#ff9800' }}>
                    {e.isActive ? "DA" : "NE"}
                  </TableCell>
                  <TableCell sx={{ color: '#ff9800' }}>{e.department}</TableCell>
                  <TableCell sx={{ color: '#ff9800' }}>{e.notes || "-"}</TableCell>
                  <TableCell>
                    <Button
                      sx={{
                        minWidth: 100,
                        backgroundColor: '#001B44',
                        color: '#ff9800',                // 🔥 tekst orange
                        border: '1px solid #ff9800',     // 🔥 border orange
                        '&:hover': {
                          backgroundColor: '#001B44',
                          border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                          color: '#ffa726'
                        }
                      }}
                      onClick={() =>
                        navigate("/worker/update", { state: e })
                      }
                    >
                      Uredi
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button
                      sx={{
                        minWidth: 100,
                        backgroundColor: '#001B44',
                        color: '#ff9800',                // 🔥 tekst orange
                        border: '1px solid #ff9800',     // 🔥 border orange
                        '&:hover': {
                          backgroundColor: '#001B44',
                          border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                          color: '#ffa726'
                        }
                      }}
                      onClick={() => setDeleteWorker(e)}
                    >
                      Obriši
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
      <Dialog
        open={!!deleteWorker}
        onClose={() => setDeleteWorker(null)}
        PaperProps={{
          sx: {
            backgroundColor: '#0f172a',
            color: '#fff',
            borderRadius: 3
          }
        }}
      >
        <DialogTitle>
          Obriši radnika
        </DialogTitle>

        <DialogContent>
          <Typography>
            Da li si siguran da želiš obrisati radnika "{deleteWorker?.firstName} {deleteWorker?.lastName}"?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setDeleteWorker(null)}
            sx={{ color: '#94a3b8' }}
          >
            Odustani
          </Button>

          <Button
            onClick={handleDeleteWorker}
            sx={{
              backgroundColor: '#dc2626',
              color: '#fff',
              '&:hover': { backgroundColor: '#b91c1c' }
            }}
          >
            Obriši
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}